<div class="container mt-1">
  <div class="card shadow-sm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">Ticket Request Form</h4>
      <h6 class="mb-0">HR Department</h6>
    </div>

    <div class="card-body">
      <div class="row g-3">

        <!-- Employee ID -->
        <div class="col-md-5">
          <label for="TR_Employeeid" class="form-label">Employee ID</label>
          <input id="TR_Employeeid" type="text" class="form-control form-control-sm"
            [(ngModel)]="add.TR_Employeeid" (KeyEnter)="OnEmployeeenter(add.TR_Employeeid)" name="TR_Employeeid">
        </div>

        <!-- Requester Mail ID -->
        <div class="col-md-5">
          <label for="TR_RequesterMailid" class="form-label">Requester Mail ID</label>
          <input id="TR_RequesterMailid" type="email" class="form-control form-control-sm"
            [(ngModel)]="add.TR_RequesterMailid" name="TR_RequesterMailid">
        </div>

        <!-- Department -->
        <div class="col-md-5">
          <label for="TR_Department" class="form-label">Department</label>
          <select id="TR_Department" class="form-select form-select-sm"
            [(ngModel)]="add.TR_Department" name="TR_Department">
            <option value="">-- Select --</option>
            <option *ngFor="let dept of departmentList" [value]="dept">{{dept}}</option>
          </select>
        </div>

        <!-- Source -->
        <div class="col-md-5">
          <label for="TR_Source" class="form-label">Source</label>
          <select id="TR_Source" class="form-select form-select-sm"
            [(ngModel)]="add.TR_Source" name="TR_Type">
            <option value="">-- Select --</option>
            <option value="Hardware">Hardware</option>
            <option value="Software">Software</option>
            <option value="BC 365 ">BC 365 </option>
          </select>
          <!-- <input id="TR_Source" type="text" class="form-control form-control-sm"
            [(ngModel)]="add.TR_Source" name="TR_Source"> -->
        </div>

        <!-- Type -->
        <div class="col-md-5">
          <label for="TR_Type" class="form-label">Request Type</label>
          <select id="TR_Type" class="form-select form-select-sm"
            [(ngModel)]="add.TR_Type" name="TR_Type">
            <option value="">-- Select --</option>
            <option value="Request">Request</option>
            <option value="Query">Query</option>
            <option value="Improvement">Improvement</option>
          </select>
        </div>

        <!-- Status -->
        <div class="col-md-5">
          <label for="TR_Status" class="form-label">Status</label>
          <select id="TR_Status" class="form-select form-select-sm"
            [(ngModel)]="add.TR_Status" name="TR_Status">
            <option value="">-- Select --</option>
            <option value="Open">Open</option>
            <option value="In Progress">In Progress</option>
            <option value="Closed">Closed</option>
          </select>
        </div>

        <!-- Priority -->
        <div class="col-md-5">
          <label for="TR_Priority" class="form-label">Priority</label>
          <select id="TR_Priority" class="form-select form-select-sm"
            [(ngModel)]="add.TR_Priority" name="TR_Priority">
            <option value="">-- Select --</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
          </select>
        </div>

        <!-- Subject -->
        <div class="col-md-5">
          <label for="TR_subject" class="form-label">Subject</label>
          <input id="TR_subject" type="text" class="form-control form-control-sm"
            [(ngModel)]="add.TR_subject" name="TR_subject">
        </div>

        <!-- Description -->
        <div class="col-md-10">
          <label for="TR_Description" class="form-label">Description</label>
          <textarea id="TR_Description" rows="3" class="form-control form-control-sm"
            [(ngModel)]="add.TR_Description" name="TR_Description"></textarea>
        </div>

        <!-- File Upload -->
        <div class="col-md-5">
          <label for="TR_Attachment" class="form-label">Attachment</label>
          <input id="TR_Attachment" type="file" class="form-control form-control-sm"
            (change)="onFileSelect($event)" name="TR_Attachment">
        </div>

      </div>

      <div class="d-grid mt-3">
        <button type="button" class="btn btn-primary btn-sm px-4" (click)="onSubmit()">Submit</button>
      </div>

    </div>
  </div>
</div>
